<div
  class="selfservice-toggle"
  [ngClass]="{ active: active() }"
  [matTooltip]="tooltipText()"
  [matTooltipPosition]="'above'"
  (click)="propagateClick()"
></div>
